import {IconName} from 'Icon/components/Icon';

export const USER_SUBSCRIPTION_MARKED_ICON = {name: IconName.UserHasSubscription, size: 18, fill: false, stroke: false};
export const HORSE_GRANTED_MARKED_ICON = {name: IconName.HorseGrantedBlack, size: 16, fill: false, stroke: false};
